/*

  File: navigation/macro.js
  Kind: Component
  Description: Top level banner for navigation back to the main with.laserts site - visibility is controlled by siteMetadata.navigation.macro

*/

import React from 'react';
import { useStaticQuery, graphql } from "gatsby"


const MacroNavigation = () => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            navigation {
              macro
            }
          }
        }
      }
    `
  )
  if (data.site.siteMetadata.navigation.macro) {
    return (
      <div>macro nav</div>
    )
  } else {
    return null
  }
}

export default MacroNavigation